import { useEffect, useState } from "react";

// Returns `value` delayed by `delay` ms. Renders keep showing `value`
// immediately; subscribers reacting to the return value see the change only
// after `delay` of inactivity. Useful for search inputs that should defer API
// calls until the user stops typing.
export function useDebounced<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}

export default useDebounced;
